<template>
  <!-- ViewApplyNotice.vue:  교육과정관리 > 교육 안내설정 화면 (eduguide.html) -->
  <fragment>
    <common-header
      subname="교육 관리"
      name="신청안내 설정"
      v-bind:menus="menus"
      v-bind:buttons="buttons"
      v-bind:mainmenuOpened="true"
    ></common-header>

    <section ref="container" class="container">
      <!-- side menus -->
      <common-side-menu :menus="side_menus"></common-side-menu>
      <div class="container-fiuld class-making-box clearfix">
        <div class="title-box m-b-30 b-b clearfix">
          <div
            class="f-18 pull-left text-blue p-10"
            v-if="selectedCategory"
          >{{selectedCategory.name}}</div>
          <div class="btn-group pull-right p-10 p-r-0">
            <button class="btn btn-blue text-white round" @click="saveApplGuide">저장</button>
          </div>
        </div>
        <div class="clearfix"></div>
        <template v-if="selectedCategory">
          <template v-for="(guide, idx) in selectedCategory.applGuideList">
            <input
              class="form-control full-width text-left round"
              type="text"
              placeholder="분야"
              :key="`guide-title-${idx}`"
              :value="guide.title"
              @blur="changeTitle(guide, $event)"
            />
            <textarea
              class="full-width"
              cols="30"
              rows="10"
              placeholder="내용"
              :value="guide.content"
              @blur="changeContent(guide, $event)"
              :key="`guide-content-${idx}`"
            ></textarea>
            <button
              v-if="idx + 1 < selectedCategory.applGuideList.length"
              :key="`guide-remove-${idx}`"
              @click="removeGuide(idx)"
            >삭제</button>
          </template>
        </template>
        <button @click="addNewGuide">추가</button>

        <table class="table full-width m-t-30">
          <caption class="f-16 text-left m-b-10">[ 작성 예시 ]</caption>

          <thead>
            <tr class="bg-lightgray">
              <th width="120">분야</th>
              <th>내용</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td class="text-center">병영 언어 예절</td>
              <td>
                병영 언어 순화를 목적으로 하는 강좌. 군대 용어 순화, 어법에 맞지 않는 표현 개선,
                언어폭력 예방, 군대 내 차별 표현 및 성차별 성희롱 표현 개선에 대한 교육
              </td>
            </tr>
            <tr>
              <td class="text-center">어문규범의 이해</td>
              <td>
                한글 맞춤법, 띄어쓰기, 표준어 규정, 표준 발음법, 외래어 표기법, 국어의 로마자 표기법
                등의 어문 규범의 내용을 개괄적으로 설명함.
              </td>
            </tr>
            <tr>
              <td class="text-center">한글 맞춤법</td>
              <td>한글 맞춤법의 원리와 실제 사례를 설명함.</td>
            </tr>
          </tbody>
        </table>
      </div>
    </section>
    <common-footer></common-footer>
    <modal-confirm
      :config="modals.ModalConfirm"
      :key="hash(modals.ModalConfirm)"
      @yes="modals.ModalConfirm.show=false"
      @no="modals.ModalConfirm.show=false"
    ></modal-confirm>
    <modal-alert
      :config="modals.ModalAlert"
      :key="hash(modals.ModalAlert)"
      @close="modals.ModalAlert.show=false"
    ></modal-alert>
  </fragment>
</template>

<script>
//import ModalAlert from '../modals/ModalAlert.vue'
//import axios from 'axios'
import fnAdjustHeight from "../mixins/fnAdjustHeight.js";
//import VueDraggable from 'vuedraggable'
import CommonHeader from "../components/CommonHeader.vue";
import CommonFooter from "../components/CommonFooter.vue";
import CommonSideMenu from "../components/CommonSideMenu.vue";
import ModalAlert from "../modals/ModalAlert.vue";
import ModalConfirm from "../modals/ModalConfirm.vue";
import Axios from "axios";
import server from "../statics/server";

export default {
  // 컴포넌트 명
  name: "ViewApplyNotice",
  mixins: [fnAdjustHeight],

  // 컴포넌트가 그려지기 직전에 호출되는 함수
  mounted: function() {
    this.getCategoryData();
  },

  components: {
    CommonHeader,
    CommonFooter,
    CommonSideMenu,
    ModalAlert,
    ModalConfirm
  },

  // 이 컴포넌트에서 내부적으로 사용할 데이터
  data: function() {
    return {
      modals: {
        ModalAlert: ModalAlert.default(),
        ModalConfirm: ModalConfirm.default()
      },
      buttons: [], // 헤더버튼
      menus: [
        // 서브메뉴
        { name: "강좌 분류", link: "/categories", selected: false },
        { name: "강좌개설 초기값", link: "/default", selected: false },
        { name: "신청안내 설정", link: "/guides/apply", selected: true }
      ],
      side_menus: [
        // 사이드 메뉴
      ],
      selectedCategory: null
    };
  },

  // 이 컴포넌트에서 내부적으로 사용할 메써드
  methods: {
    // 대분류 데이터 가져오기
    getCategoryData: async function() {
      try {
        const { data } = await Axios.post(
          `${server.addr()}${server.api.CATEGORY_ALL}`,
          {}
        );
        data.list = data.list.map(category => {
          if (!category.applGuideList || category.applGuideList.length == 0)
            category.applGuideList = [{ content: "", title: "" }];
          return category;
        });

        this.side_menus = data.list
          .filter(ele => ele.parentsId === 0)
          .map(value => {
            if (!this.selectedCategory) this.selectedCategory = value; // 가장 첫번째 category를 선택하게 해둔다.
            const sub_menus = value.child.map(ele => {
              ele.applGuideList = [{ content: "", title: "" }];
              return {
                name: ele.name,
                fn: this.selectCategory(ele),
                category: ele
              };
            });

            return {
              category: value,
              name: value.name,
              sub_menus,
              fn: this.selectCategory(value),
              selected: value === this.selectedCategory
            };
          });
      } catch (e) {
        this.modals.ModalAlert.msg = "서버 오류입니다.";
        this.modals.ModalAlert.show = true;
      }
    },

    // 메뉴 선택 시 작동하는 함수를 만들어주는 함수
    selectCategory: function(category) {
      return () => {
        this.selectedCategory = category;

        this.side_menus = this.side_menus.map(menu => {
          if (category === menu.category) menu.selected = true;
          else menu.selected = false;

          if (menu.sub_menus) {
            menu.sub_menus = menu.sub_menus.map(sub_menu => {
              if (category === sub_menu.category) sub_menu.selected = true;
              else sub_menu.selected = false;

              return sub_menu;
            });
          }

          return menu;
        });
      };
    },
    changeTitle: function(guide, $event) {
      guide.title = $event.target.value;
    },
    changeContent: function(guide, $event) {
      guide.content = $event.target.value;
    },
    addNewGuide: function() {
      this.selectedCategory.applGuideList.push({
        title: "",
        content: ""
      });
    },
    removeGuide: function(idx) {
      this.selectedCategory.applGuideList.splice(idx, 1);
    },
    saveApplGuide: async function() {
      try {
        await Axios.patch(
          `${server.addr()}${server.api.CATEGORY}/${
            this.selectedCategory.categoryId
          }`,
          { applGuideList: this.selectedCategory.applGuideList }
        );
        this.modals.ModalAlert.msg = "수정되었습니다.";
        this.modals.ModalAlert.show = true;
      } catch (e) {
        this.modals.ModalAlert.msg = "서버 오류입니다.";
        this.modals.ModalAlert.show = true;
      }
    }
  }
};
</script>
<style>
.white-box.head {
  margin-bottom: 15px;
}
.white-box.head + .white-box {
  margin-top: -10px;
}
.white-box {
  margin-top: 5px;
}
.white-box + .white-box.head {
  margin-top: 30px;
}

td {
  white-space: normal !important;
}
</style>
